import React, { useState } from "react";
import { api } from "../../api";

// Single password input with show/hide eye toggle.
// type="password" by default for masking + password-manager integration;
// briefly flips to type="text" when the user clicks the eye so they can verify typos.
function PwdField({ h, label, value, onChange, placeholder, autoFocus }) {
  const [show, setShow] = useState(false);
  return (
    <div style={{ marginBottom: 12 }}>
      <label style={{ color: h.ts, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.3px" }}>{label}</label>
      <div style={{ position: "relative" }}>
        <input
          type={show ? "text" : "password"}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          autoFocus={autoFocus}
          autoComplete={label.toLowerCase().includes("current") ? "current-password" : "new-password"}
          style={{ width: "100%", padding: "10px 40px 10px 12px", borderRadius: 10, border: `1px solid ${h.bd}`, background: h.ib, color: h.tx, fontSize: 14, outline: "none", boxSizing: "border-box" }}
        />
        <button
          type="button"
          onClick={() => setShow(s => !s)}
          aria-label={show ? "Hide password" : "Show password"}
          style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer", padding: 6, color: h.sc, fontSize: 14 }}
        >{show ? "\uD83D\uDE48" : "\uD83D\uDC41"}</button>
      </div>
    </div>
  );
}

const ChangePasswordModal = ({ h, t, onClose, onSuccess }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    setErr("");
    if (!current) return setErr(t.enterCurrentPwd || "Please enter your current password");
    if (next.length < 6) return setErr(t.pwdMinLen || "New password must be at least 6 characters");
    if (next === current) return setErr(t.pwdMustDiffer || "New password must be different from current password");
    if (next !== confirm) return setErr(t.pwdMismatch || "New password and confirmation do not match");

    setSubmitting(true);
    const r = await api.changePassword(current, next);
    setSubmitting(false);
    if (r && r.success) {
      if (onSuccess) onSuccess(r.message || t.pwdChanged || "Password changed successfully");
      onClose();
    } else {
      setErr((r && r.message) || t.pwdChangeFailed || "Failed to change password");
    }
  };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div style={{ background: h.cd, borderRadius: 16, padding: 20, maxWidth: 380, width: "100%", boxShadow: "0 10px 40px rgba(0,0,0,0.3)" }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
          <div style={{ width: 36, height: 36, borderRadius: 12, background: `${h.rd}15`, display: "flex", alignItems: "center", justifyContent: "center" }}><span style={{ fontSize: 18 }}>{"\uD83D\uDD12"}</span></div>
          <div>
            <div style={{ color: h.tx, fontWeight: 700, fontSize: 15 }}>{t.changePassword || "Change Password"}</div>
            <div style={{ color: h.sc, fontSize: 11 }}>{t.changePasswordHint || "You'll need your current password to confirm."}</div>
          </div>
        </div>

        <PwdField h={h} label={t.currentPassword || "Current Password"} value={current} onChange={setCurrent} placeholder={t.enterCurrentPwd || "Enter current password"} autoFocus />
        <PwdField h={h} label={t.newPassword || "New Password"} value={next} onChange={setNext} placeholder={t.newPasswordPh || "At least 6 characters"} />
        <PwdField h={h} label={t.confirmNewPassword || "Confirm New Password"} value={confirm} onChange={setConfirm} placeholder={t.confirmNewPasswordPh || "Re-enter new password"} />

        {err ? <div style={{ color: h.rd, background: `${h.rd}15`, borderRadius: 8, padding: "8px 10px", fontSize: 12, marginBottom: 10 }}>{err}</div> : null}

        <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
          <button onClick={onClose} disabled={submitting} style={{ flex: 1, padding: "11px", borderRadius: 10, border: `1px solid ${h.bd}`, background: "transparent", color: h.tx, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>{t.cancel || "Cancel"}</button>
          <button onClick={submit} disabled={submitting} style={{ flex: 1, padding: "11px", borderRadius: 10, border: "none", background: submitting ? h.sc : h.ac, color: "#fff", fontSize: 13, fontWeight: 700, cursor: submitting ? "not-allowed" : "pointer" }}>
            {submitting ? (t.saving || "Saving\u2026") : (t.updatePassword || "Update Password")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
